import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import getCommonLocales from '../../../locales/locales_common';

import styles from './blog_preview.module.scss';

function BlogPreview({ className, cardData }) {
  const { locale } = useRouter();
  const dictionary = getCommonLocales(locale);
  const { title, url_name, category, cover_image, header } = cardData.attributes;

  const { url } = cover_image.data?.attributes?.formats?.medium ? cover_image.data?.attributes?.formats?.medium : cover_image.data?.attributes?.formats?.thumbnail;
  const alternativeText = cover_image.data?.attributes.alternativeText?.length > 0 ? cover_image.data?.attributes.alternativeText : title;

  const isExternalLink = title.includes("external_link");

  return (
    <div className={styles[`container-${className}`]}>
      <div className={styles[`image-box-${className}`]}>
        {isExternalLink ?
          <a href={url_name} target="_blank" rel="noreferrer">
            <Image src={url} alt={alternativeText} className={styles[`image-${className}`]} width="400" height="210" loading="lazy" unoptimized={true} />
          </a>
          :
          <Link href={`/blog/${url_name}`}>
            <Image src={url} alt={alternativeText} className={styles[`image-${className}`]} width="400" height="210" loading="lazy" unoptimized={true} />
          </Link>}
      </div>
      {isExternalLink ?
        <>
          <a href={url_name} target="_blank" rel="noreferrer">
            <h2 className={styles.title}>{header ? header : title}</h2>
          </a>
        </>
        :
        <>
          <Link href={`/blog/categories/${category.data?.attributes.name.toLowerCase()}`}><h3 className={styles.category}>{dictionary[category.data?.attributes.name] || category.data?.attributes.name}</h3></Link>
          <Link href={`/blog/${url_name}`}><h2 className={styles.title}>{header ? header : title}</h2></Link>
        </>
      }
    </div >
  );
}
export default BlogPreview;